import "core-js/modules/es.function.name.js";
import env from '@tencent/vft-common/env';
import phone from './phone';
import ipad from './ipad';
import mac from './mac';
import pc from './pc';
import h5 from './h5';
import wetv from './wetv';
import kid from './kid';
import weishi from './weishi';
import tva from './tva';
import qqsports from './qqsports';
import qqmusic from './qqmusic';
import { getVersion } from './lib/Version'; // eslint-disable-next-line

var JSBridge;

if (env.isWeishi) {
  JSBridge = weishi;
} else if (env.isTenvideoUnion) {
  JSBridge = tva;
  window.TVAJSBridge = tva;
} else if (env.isQQSports) {
  JSBridge = qqsports;
} else if (env.isQQMusic) {
  JSBridge = qqmusic;
} else if (!env.isApp) {
  JSBridge = h5;
} else if (env.isWetv) {
  JSBridge = wetv;
} else if (env.isKidApp) {
  JSBridge = kid;
} else {
  switch (env.device) {
    case 'mac':
      JSBridge = mac;
      break;

    case 'windows':
      JSBridge = pc;
      break;

    case 'ipad':
    case 'apad':
      JSBridge = ipad;
      break;

    default:
      JSBridge = phone;
  }
}

if (env.isBaseApp && getVersion().compare('8.2.5')) {
  // 8.2.5 版本开始主线版本走 phone 端接口
  JSBridge = phone;
}

console && console.log("[atom] Using ".concat(JSBridge.name, "!"));
export default JSBridge;